<template>
  <span class="as_badge label label-info js-tooltip" data-title="Autosomministrazione"> AS </span>
</template>
<script>
export default {
  name: 'asLabel',
};
</script>
